var m = require('mithril');
var prop = require("mithril/stream");
var slimdown = require('slimdown-js');
var sanitizeMarkdownHtml = require('../libs/sanitizeMarkdownHtml');
require('../../stylesheets/mark-down/markdown.css');
var loadingModal = require('../layout/components/loadingModal');
var Model = require('../libs/Model');
var helpModal = Object.create(Model);

var modelOptions={}

helpModal.editDialogue = async function (title, helpFileName, markdownText) {

  if (helpFileName) {
    var response = await fetch(`/markdown/help/${helpFileName}`);
    helpModal.text = await response.text();    
  } else {
    helpModal.text = markdownText;
  }
  loadingModal.vm.title(title);
  loadingModal.vm.body = helpModal.view, 
  loadingModal.vm.open(modelOptions);
  m.redraw();
}
helpModal.close = function (){
  loadingModal.vm.close();
  m.redraw();
}

helpModal.view = function () {
  return m('div.markdown-content', {role:'form'}, [
      m('div.markdown-body.mw8', { style: 'background: none;' }, [
        m.trust(sanitizeMarkdownHtml(slimdown.render(helpModal.text)))
      ])
  ])
}

module.exports = helpModal;
